import { useLocation } from "react-router-dom";

const useSlug = () => {
  const { pathname } = useLocation();
  return pathname.replace(/^\/+/, "");
};

export default useSlug;
